// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__tavBF","createdSearch":"index_createdSearch__Rczz0","custom_table":"index_custom_table__g43cX"};